module.exports = __webpack_public_path__ + "img/omimg5.df6b9b1c.png";